import css from './CreditConfirmation.module.css';
import React, { useState } from 'react';
import { IoSpeedometerOutline, IoHomeOutline } from "react-icons/io5";
import { ImCalendar } from "react-icons/im";
import { BsCreditCard } from "react-icons/bs";
import { MdOutlineCheckBox, MdOutlineCheckBoxOutlineBlank } from "react-icons/md";

const CreditConfirmation = ({ project, step, setStep, nextStep, prevStep, basket, contractDuration = 1, upfront = 0, monthly = 0 }) => {
    const [isChecked, setIsChecked] = useState(false);

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };

    

    return (
        <div className={css.proceedBox}>
            <div className={css.messageBox}>
                <h2>Equipment Financing</h2>
                <div className={css.descriptionBox}>
                    <div className={css.description}>
                        <p className={css.messageInstruction}>Before approving a contract sale, Securepol will conduct the following verifications to confirm eligibility for equipment financing:</p>
                    </div>
                </div>
                
                <div className={css.itemBox}>
                    <div className={css.itemWrapper}>
                        <div className={css.icon}>
                            <IoSpeedometerOutline />
                        </div>
                        <div className={css.item}>
                        <p>Customer Credit Check</p>
                        </div>
                    </div>
                </div>
                
                <div className={css.itemBox}>
                    <div className={css.itemWrapper}>
                        <div className={css.icon}>
                        <IoHomeOutline />
                        </div>
                        <div className={css.item}>
                        <p>Home Ownership Title Check</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className={css.buttonBox}>
                <div className={css.checkboxBox} >
                    <div className={css.checkbox} onClick={handleCheckboxChange}>
                    {isChecked?<MdOutlineCheckBox/>:<MdOutlineCheckBoxOutlineBlank/>}
                    </div>
                    <div className={css.term}>
                    <p>I acknowledge and accept these conditions</p>
                    </div>
                </div>
                <button 
                    className={css.buttonActive} 
                    onClick={()=>setStep(6)} 
                    >
                        Back
                    </button>
                <button 
                    className={isChecked ? css.buttonActive : css.buttonInActive} 
                    onClick={()=>setStep(upfront>0?8:9)} 
                    disabled={!isChecked}
                    >
                        Next
                    </button>
            </div>
        </div>
    );
};

export default CreditConfirmation;







